import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, hasAuthParams } from "react-oidc-context";

import { Layout, Menu } from "antd";

// import {
//   IconChartBarGraphDataInsights24x24,
//   IconActivityLogFilled,
// } from "@ttd/icons";

import { InteractionFilled, DashboardFilled } from "@ant-design/icons";

const { Header, Content, Sider } = Layout;

function MainLayout(props) {
  const auth = useAuth();
  const { children } = props;
  const navigate = useNavigate();
  const [hasTriedSignin, setHasTriedSignin] = useState(false);
  const [current, setCurrent] = useState(
    window.location.href.indexOf("dashboard") > 0 ? "dashboard" : "form"
  );

  useEffect(() => {
    if (
      !hasAuthParams() &&
      !auth.isAuthenticated &&
      !auth.activeNavigator &&
      !auth.isLoading &&
      !hasTriedSignin
    ) {
      auth.signinRedirect();
      setHasTriedSignin(true);
    }
    return auth.events.addUserLoaded(() => navigate("/"));
  }, [auth, hasTriedSignin, navigate]);

  const ttd_logo = (
    <object data="images/kokai-header-logo.svg" type="image/svg+xml">
      <img src="images/kokai-header-logo.svg" alt="ttd logo" />
    </object>
  );

  const items = [
    {
      key: "home",
      icon: ttd_logo,
      label: "Home",
    },
    {
      key: "form",
      icon: (
        <a style={{ color: "white" }} href="/">
          <InteractionFilled />
        </a>
      ),
      label: "Form",
    },
    {
      key: "dashboard",
      icon: (
        <a
          style={{ backgroundColor: "transparent", color: "white" }}
          href="/dashboard"
        >
          <DashboardFilled />
        </a>
      ),
      label: "Dashboard",
    },
  ];

  const onClick = (e) => {
    setCurrent(e.key);
  };

  return (
    <div>
      <Layout style={{ minHeight: "100vh" }}>
        <Sider
          collapsed={true}
          style={{ padding: 0, backgroundColor: "rgb(18,20,98)" }}
        >
          <div className="demo-logo-vertical" />
          <Menu
            onClick={onClick}
            selectedKeys={[current]}
            items={items}
            style={{ backgroundColor: "rgb(18,20,98)" }}
          />
        </Sider>
        <Layout>
          <Header style={{ backgroundColor: "white" }}>
            <img
              src="images/TTD_Lockup_BlackInk.png"
              height="15"
              alt="Logo1"
              style={{ backgroundColor: "white" }}
            />
          </Header>
          <Content style={{ margin: "0 16px" }}>
            {auth.isAuthenticated ? (
              children
            ) : (
              <div>Redirecting to TTD Desk for signing in ...</div>
            )}
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}

export default MainLayout;
